<template>
  <div>

<!-- this component is currently used on snow, const, and lawn overview pages (but not irrigation) -->
<!-- once edited, irrigation will point here as well - MJ  -->

    <wc-data-box
      :title='title'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      showEdit
      @edit='editContacts'
    >
      <v-simple-table dense>
        <tbody>
          <template v-for='(c, i) in contacts'>
            <tr :key='i'>
              <td :class='label'>{{c.type}}</td>
              <td :class='c.obj ? dataValue : emptyDataValue'>
                {{ c.obj ? c.obj.name_display : 'Not Set' }}
                <v-btn v-if='c.obj' icon small @click="contactCard(c.obj, c.type)">
                  <v-icon :color='(c.obj.on_hold || c.obj.archived) ? "error" : "grey"'>
                    {{ c.obj.archived ? 'mdi-account-cancel' : 'mdi-account-circle' }}
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </wc-data-box>


<!-- CONTACT CARD DIALOG (contact quick view)-->

    <wc-contact-card-dialog
      :showDialog='showCard'
      :contact='contact'
      @close='showCard = false'
    ></wc-contact-card-dialog>


<!-- EDIT CONTACTS DIALOG -->
    <wc-dialog
      :showDialog='showEditContacts'
      :loading='isLoading'
      :title='title'
      :icon='$store.state.icons.modules.clients.icon'
      :disableButtons='!isContactFormValid || isLoading'
      @cancel='cancelEditContacts'
      @save='update'
      width='400'

    >
      <v-form v-model='isContactFormValid'>
        <contacts-form
          :newContacts='newContacts'
          v-model='projectCopy'
          @loading='setLoading'
        ></contacts-form>
      </v-form>
      <template v-slot:dialog-actions>
        <v-btn text small color='success' @click='addContact'>
          Create Contact
        </v-btn>
      </template>
    </wc-dialog>

    <wc-quick-create-client
      ref='quickCreateDialog'
      :showQuickCreate='showQuickCreate'
      @cancel='showQuickCreate = false'
      @save='saveQuickCreate'
    ></wc-quick-create-client>

  </div>
</template>

<script>
import _ from 'lodash'
import WCContactCardDialog from '@/components/dialogs/WCContactCardDialog'
import ContactsForm from '@/modules/projects/components/forms/ContactsForm'
import WCQuickCreateClient from '@/components/clients/WCQuickCreateClient'

export default {
  name: 'project-contacts',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    newContacts: [],
    showCard: false,
    showEditContacts: false,
    openInNewIcon: 'mdi-open-in-new',
    showQuickCreate: false,
    isContactFormValid: false,
    title: 'Contacts',
    label: 'grey--text',
    dataValue: 'text-right pr-2',
    emptyDataValue: 'text-right pr-2 grey--text font-italic',
    contact: {},
    projectCopy: {}
  }),
  computed: {
    contacts() {
      let tmp = [
        { type: 'Owner', obj: this.project.owner_obj },
        { type: 'Billing Contact', obj: this.project.bill_to_obj },
        { type: 'Notices Contact', obj: this.project.notices_contact_obj }
      ]
      if (this.project.division_obj.division === 'Irrigation') {
        tmp.push({ type: 'Sales Contact', obj: this.project.sales_contact_obj })
        tmp.push({ type: 'Install Contact', obj: this.project.install_contact_obj })
        // MJError - as of 2021-10-04 irrigation service contacts are stored in the site field, even though we have a service field.
        // need to bulk move these to the right field, and adjust below.
        tmp.push({ type: 'Primary Service Contact', obj: this.project.site_contact_obj })
        tmp.push({ type: 'Secondary Service Contact', obj: this.project.secondary_site_contact_obj })
      } else {
        tmp.push({ type: 'Site Contact', obj: this.project.site_contact_obj })
        tmp.push({ type: 'Secondary Site Contact', obj: this.project.secondary_site_contact_obj })
      }
      return tmp
    }
  },
  methods: {
    contactCard (cont, contType) {
      this.contact = _.cloneDeep(cont)
      this.contact.contact_type = contType
      this.showCard = true
    },
    closeCard () {
      this.showCard = false
    },
    addContact () {
      this.showQuickCreate = true
      this.$refs.quickCreateDialog.resetForm()
    },
    editContacts () {
      this.projectCopy = _.cloneDeep(this.project)
      console.log('edit called')
      this.showEditContacts = true
    },
    cancelEditContacts () {
      this.showEditContacts = false
    },
    update () {
      console.log(JSON.parse(JSON.stringify(this.projectCopy)))
      this.$emit('update', this.projectCopy)
      this.showEditContacts = false
    },
    async saveQuickCreate (newClient) {
      this.newContacts.push(newClient)
      this.newContacts = _.orderBy(this.newContacts, 'name_display')
      this.showQuickCreate = false
    },
    setLoading (val) {
      this.isLoading = val
    }
  },
  components: {
    'contacts-form': ContactsForm,
    'wc-quick-create-client': WCQuickCreateClient,
    'wc-contact-card-dialog': WCContactCardDialog
  }
}
</script>
